import { render, staticRenderFns } from "./good2.vue?vue&type=template&id=318b70aa&scoped=true&"
import script from "./good2.vue?vue&type=script&lang=js&"
export * from "./good2.vue?vue&type=script&lang=js&"
import style0 from "./good2.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good2.vue?vue&type=style&index=1&id=318b70aa&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b70aa",
  null
  
)

export default component.exports